import type { GetAppointmentBookingResponse } from "@/openapi/generated";

export const CANCELED_BOOKING_STATUSES = new Set([
  "Canceled",
  "canceled",
  "Cancelled",
  "cancelled",
]);

export function isCanceledBookingStatus(
  status: string | null | undefined,
): boolean {
  if (!status) return false;
  return CANCELED_BOOKING_STATUSES.has(status);
}

export function isBookedBookingStatus(
  status: string | null | undefined,
): boolean {
  if (!status) return false;
  return status.trim().toLowerCase() === "booked";
}

export function getAppointmentSlotKey(start: Date, end: Date): string {
  return `${start.toISOString()}-${end.toISOString()}`;
}

export function bookingBelongsToStudent(
  booking: GetAppointmentBookingResponse,
  studentId: number | string | null | undefined,
): boolean {
  if (studentId == null) return false;
  return Number(booking.student?.studentId) === Number(studentId);
}

export function hasStudentBookingForSlot(
  bookings: GetAppointmentBookingResponse[] | undefined,
  studentId: number | string | null | undefined,
  start: Date,
  end: Date,
): boolean {
  if (!Array.isArray(bookings) || studentId == null) return false;

  const slotKey = getAppointmentSlotKey(start, end);

  return bookings.some((booking) => {
    if (isCanceledBookingStatus(booking.status)) return false;
    if (!bookingBelongsToStudent(booking, studentId)) return false;
    if (!booking.startTime || !booking.endTime) return false;

    const startDate =
      booking.startTime instanceof Date
        ? booking.startTime
        : new Date(booking.startTime);
    const endDate =
      booking.endTime instanceof Date
        ? booking.endTime
        : new Date(booking.endTime);

    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
      return false;
    }

    return getAppointmentSlotKey(startDate, endDate) === slotKey;
  });
}
